import { FileSource } from "./file.types";
import { GeoLocation, Visit } from "./geo.types";
import { Subscription } from "./subscription.types";

// MAIN
export type User = {
  id: string;
  email: string;
  referrerCode: string;
  role: UserRole;
  status: UserStatus;
};
export type UserDetailedInfo = {
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
  phoneNumber: string;
  locationResidence: GeoLocation;
  locationOrigin: GeoLocation;
  additionalLocations: GeoLocation[];
  occupation?: string;
  locationWorkplace?: string;
  profileImage: FileSource;
  profilePreview?: FileSource;
  photos: FileSource[];
  hasInfiniteFreeTrial: boolean | null;
  freeTrialEndDate?: string;
  introduction: string;
  isEmailVerified: boolean;
  socialLinks?: {
    instagram: string;
  };
  accomplishments?: UserAccomplishment[];
  interests: UserInterest[];
  travels: TravelPlan[];
  isFreeTonight: boolean;
  contacts: string[];
  filterLocations: GeoLocation[];
  filterEventsLocations: GeoLocation[];
  hasEnabledNotifications: boolean;
  currentLocation?: GeoLocation;
  isDeleted?: boolean;
  hasPassword?: boolean;
  subscription?: Subscription;
  featureFlags: UserFeatureFlag[];
  remainingInvitesCount: number;
  card?: UserCard;
  isHidden?: boolean;
};
export type MemberDetailedInfo = UserDetailedInfo & {
  lastSeen: string;
  distanceKilometers: number;
  admiredByMe?: boolean;
  blockedByMe?: boolean;
  mutualUsers?: Array<
    Pick<User, "id" | "role"> &
      UserDetailedInfo & {
        lastSeen: string;
      }
  >;
  visit?: Visit;
  distanceToClosestTravelKilometers?: number;
  closestTravel?: {
    location: GeoLocation;
    startDate: string;
    endDate: string;
  };
};

// ADDITIONAL
export type UserRole = "muse" | "alpha";
export enum UserStatus {
  NOT_ONBOARDED = "not-onboarded",
  PENDING = "pending",
  INACTIVE = "inactive",
  ACTIVE = "active",
  NOT_FINISHED_PROFILE = "not-finished-profile",
}
export type UserAccomplishment = {
  description: string;
  link: string;
};
export type UserInterest = {
  id: string;
  body: string;
};
export type TravelPlan = {
  location: GeoLocation;
  startDate?: string;
  endDate?: string;
};
export enum UserFeatureFlag {
  EARLY_TESTER = "early-tester",
}
export type UserCard = {
  exp: string;
  number: string;
  type?: "visa" | "mastercard";
};
